import { ElementType, forwardRef } from "react";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { TextFieldProps } from "@mui/material/TextField";
import { useCustomColors } from "../../hooks/useCustomColors";

export type AuthFieldProps = TextFieldProps & {
  label: string;
  icon: ElementType;
};

const AuthField = forwardRef<HTMLInputElement, AuthFieldProps>(
  ({ label, icon: Icon, sx, ...props }, ref) => {
    const colors = useCustomColors();

    return (
      <Box sx={{ mb: "16px" }}>
        <Typography
          sx={{
            mb: "8px",
            fontSize: "12.5px",
            fontWeight: 700,
            color: colors.text.primary,
          }}
        >
          {label}
        </Typography>
        <TextField
          fullWidth
          inputRef={ref}
          {...props}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: colors.tint.gold,
                  }}
                >
                  <Icon
                    sx={{ fontSize: "16px", color: colors.accent.gold }}
                  />
                </Box>
              </InputAdornment>
            ),
            ...props.InputProps,
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              minHeight: "52px",
              pl: "12px",
              backgroundColor: colors.background.field,
              borderRadius: "14px",
              "& fieldset": { borderColor: colors.border.accent },
              "&:hover fieldset": { borderColor: colors.border.hover },
              "&.Mui-focused fieldset": { borderColor: colors.border.focus }, "&.Mui-focused": { boxShadow: `0 0 0 3px ${colors.tint.primaryStrong}` },
              "& input, & .MuiSelect-select": {
                color: colors.text.primary,
                fontSize: "14px",
              },
            },
            "& .MuiFormHelperText-root": {
              color: colors.accent.danger,
              fontSize: "11px",
              marginLeft: 0,
            },
            ...sx,
          }}
        />
      </Box>
    );
  }
);

export default AuthField;
